import { z } from "zod"

const publicEnvSchema = z.object({
  NEXT_PUBLIC_APP_URL: z.string().url().default("http://localhost:6967"),
  NEXT_PUBLIC_API_URL: z.string().url().optional(),
  NEXT_PUBLIC_INGEST_URL: z.string().url().optional(),
  NEXT_PUBLIC_WEB_PUSH_VAPID_KEY: z.string().optional(),
})

export const publicEnv = publicEnvSchema.parse({
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_INGEST_URL: process.env.NEXT_PUBLIC_INGEST_URL,
  NEXT_PUBLIC_WEB_PUSH_VAPID_KEY: process.env.NEXT_PUBLIC_WEB_PUSH_VAPID_KEY,
})

